import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Footer } from "./Footer";

export const LegalLayout = ({ title, updated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen bg-[#0a0e1a]">
      <div className="grain-overlay" />

      <header className="border-b border-white/5">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-5 lg:px-10">
          <Link
            to="/"
            data-testid="legal-logo"
            className="flex items-center gap-2.5"
          >
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full rounded-full bg-[#c9a84c] opacity-60 breathe" />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#e8c97a]" />
            </span>
            <span className="text-sm font-semibold uppercase tracking-[0.32em] text-white">
              Nuit&nbsp;Calme
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-sm text-white/60 transition-colors duration-300 hover:text-white"
          >
            <ArrowLeft className="h-4 w-4" strokeWidth={1.6} />
            Retour à l’accueil
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-20 md:py-28 lg:px-10">
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.3em] text-[#c9a84c]">
          Informations légales
        </p>
        <h1 className="text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl">
          {title}
        </h1>
        {updated && (
          <p className="mt-4 text-sm text-white/40">Dernière mise à jour : {updated}</p>
        )}

        <div className="legal-content mt-14 space-y-12">{children}</div>
      </main>

      <Footer />
    </div>
  );
};

export const LegalSection = ({ n, title, children }) => (
  <section>
    <h2 className="flex items-baseline gap-3 text-xl font-medium tracking-tight text-white sm:text-2xl">
      <span className="text-sm font-light text-[#c9a84c]/70">{n}</span>
      {title}
    </h2>
    <div className="mt-4 space-y-4 text-base leading-relaxed text-white/60">
      {children}
    </div>
  </section>
);
